import React, { useEffect, useRef, useState, forwardRef, useCallback } from 'react';
import { Box, Paper } from '@mui/material';
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import { gantt } from 'dhtmlx-gantt';
import api from '../../services/api';
import { useSnackbar } from 'notistack';

const GanttChartHierarchicalFixed = forwardRef(({ projectId, onAddTask, onEditTask, onRefresh }, ref) => {
  const ganttContainer = useRef(null);
  const [, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  
  // Store original gantt data for filtering
  const [, setGanttData] = useState({ data: [], links: [] });

  // Basic functions - simplified for old file
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get(`/projects/${projectId}/gantt`);
      if (response.data && response.data.success) {
        const { data, links } = response.data;
        setGanttData({ data, links });
        gantt.clearAll();
        gantt.parse({ data, links });
      }
    } catch (error) {
      console.error('Error loading Gantt data:', error);
      enqueueSnackbar('Error loading Gantt Chart data', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [projectId, enqueueSnackbar, setLoading, setGanttData]);

  // Basic initialization
  useEffect(() => {
    if (ganttContainer.current) {
      gantt.init(ganttContainer.current);
      loadData();
    }
    
    return () => {
      gantt.clearAll();
      gantt.detachAllEvents();
    };
  }, [loadData]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Paper 
        elevation={2} 
        sx={{ 
          flexGrow: 1, 
          p: 2, 
          display: 'flex', 
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <div 
          ref={ganttContainer} 
          style={{ 
            width: '100%', 
            height: '100%', 
            minHeight: '400px' 
          }}
        />
      </Paper>
    </Box>
  );
});

export default GanttChartHierarchicalFixed;
